import Vue from 'vue'
import DisplayDatetime from './DisplayDatetime'
import QueryLoader from './QueryLoader'
import JobsConsumer from './JobsConsumer'

Vue.component('display-datetime', DisplayDatetime)
Vue.component('query-loader', QueryLoader)
Vue.component('jobs-consumer', JobsConsumer)
